import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedHTMLMessage } from 'react-intl';
import './styles.css';

class BodyRightLabel extends Component {
	render() {
		return (
			<div className="sales-test-layout-body-right-label">
				<FormattedHTMLMessage id={this.props.label} />
			</div>
		);
	}
}

BodyRightLabel.propTypes = {
	label: PropTypes.string
};
export default BodyRightLabel;
